import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, List, Tag, Button, Space } from 'antd';
import { FileOutlined, SafetyOutlined, ClockCircleOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import api from '../services/api';

interface Contract {
  id: string;
  title: string;
  upload_time: string;
  risk_level: string;
  status: string;
}

const Dashboard: React.FC = () => {
  const [recentContracts, setRecentContracts] = useState<Contract[]>([]);
  const [stats, setStats] = useState({
    total: 0,
    audited: 0,
    highRisk: 0,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get('/contracts');
      const contracts = response.data;
      
      setRecentContracts(contracts.slice(0, 5));
      setStats({
        total: contracts.length,
        audited: contracts.filter((c: Contract) => c.status === '已审核').length,
        highRisk: contracts.filter((c: Contract) => c.risk_level === '高风险').length,
      });
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };

  const getRiskTagColor = (level: string) => {
    switch (level) {
      case '高风险': return 'red';
      case '中风险': return 'orange';
      case '低风险': return 'blue';
      default: return 'default';
    }
  };

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>工作台</h1>
      
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总合同数"
              value={stats.total}
              prefix={<FileOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="已审核"
              value={stats.audited}
              prefix={<SafetyOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="高风险合同"
              value={stats.highRisk}
              valueStyle={{ color: '#cf1322' }}
              prefix={<ArrowUpOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="待处理"
              value={stats.total - stats.audited}
              prefix={<ClockCircleOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={16}>
          <Card title="最近合同" extra={<Link to="/contracts">查看全部</Link>}>
            <List
              dataSource={recentContracts}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Link to={`/audit/${item.id}`}>查看详情</Link>
                  ]}
                >
                  <List.Item.Meta
                    title={item.title}
                    description={`上传时间: ${new Date(item.upload_time).toLocaleString()}`}
                  />
                  {item.risk_level && (
                    <Tag color={getRiskTagColor(item.risk_level)}>
                      {item.risk_level}
                    </Tag>
                  )}
                </List.Item>
              )}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card title="快捷操作">
            <Space direction="vertical" style={{ width: '100%' }}>
              <Button type="primary" block icon={<FileOutlined />}>
                <Link to="/upload">上传新合同</Link>
              </Button>
              <Button block>
                <Link to="/templates">使用合同模板</Link>
              </Button>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;